module.exports = __webpack_public_path__ + "static/title-company-3d4d023713a67f180b0e946694d2ebf4.png";